import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface EventDescriptionProps {
  description: string;
}

export function EventDescription({ description }: EventDescriptionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>About Event</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          className="prose prose-stone max-w-none whitespace-pre-wrap"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </CardContent>
    </Card>
  );
}
